<div class="aside">
    <div class="overlay"></div>
    <div class="icon"></div>
    <div class="title">Administer your NetFoundry Ziti Virtual Network with Ziti Admin console</div>
    <div class="title">{{version}}</div>
</div>
